module.exports = __webpack_public_path__ + "static/img_1833-91b390687605c01f056fdbc3007ff84c.webp";